import ClearIcon from "@mui/icons-material/Clear";
import { Box, Button, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TaskIconButton from "../../../components/common/TaskIconButton";

/**
 * ActionButtons component for Geocoder.
 *
 * This component renders action buttons for submitting geocoder tasks or creating NAT gateway.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {function} props.onSubmit - Callback function for submitting the geocoder task.
 * @param {function} props.onCreateGateway - Callback function for creating NAT gateway.
 * @param {boolean} props.natGatewayReady - Indicates if NAT gateway is ready.
 * @param {boolean} props.natGatewayLoading - Indicates if NAT gateway is loading.
 * @param {boolean} props.taskSubmitting - Indicates if a task is currently being submitted.
 *
 * @returns {JSX.Element} - The JSX element for the action buttons component.
 */
const ActionButtons = ({ onSubmit, onCreateGateway, natGatewayReady, natGatewayLoading, taskSubmitting }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {natGatewayReady ? (
        <Button 
          variant="outlined" 
          color="primary" 
          onClick={onSubmit} 
          disabled={natGatewayLoading || taskSubmitting}
        >
          Create Geocoder Task
        </Button>
      ) : (
        <Button
          variant="outlined"
          color="secondary"
          onClick={onCreateGateway}
          disabled={natGatewayLoading}
          startIcon={natGatewayLoading && <CircularProgress size={20} color="inherit" />}
        >
          {natGatewayLoading ? "Creating Gateway..." : "Create NAT Gateway"}
        </Button>
      )}
      <TaskIconButton color="error" text="Cancel" icon={<ClearIcon />} onClick={() => navigate("/tasks")} />
    </Box>
  );
};

export default ActionButtons;
